// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoaderPage_wrapper__3lVnt","loader":"LoaderPage_loader__1IusN","run":"LoaderPage_run__16_QJ","rotating":"LoaderPage_rotating__23YPN"};